import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import { withRouter } from "react-router-dom";


@inject('core')
@observer
class Start extends React.Component {
	
	constructor(props) {
		super(props)
		this.createNew = this.createNew.bind(this)
	}
	
	componentDidMount() {
		const { core, pod_id } = this.props
	}
	
	createNew() {
		var name = window.prompt('Pod Name', '')
		if ((typeof name !== 'undefined') && (name !== null) && (name.length)) {
			const pod_id = core.uuid('x')
			core.action({
				op:'addPod', 
				pod_id: pod_id, 
				name: name
			})
			this.props.history.push('/' + pod_id); 
		}
	}

	render() {
		const { core } = this.props
		
		return <div>
			No pod here.<br />
			<button onClick={this.createNew}>Create New Pod</button>
		</div>

	}
	
}

export default withRouter(Start)